/**
 * 🎥 ETAP VIDEOSI kartasi (backend: services/runRecorder.js, server.js composeRunVideo; docs/knowledge/198).
 * video = { status: 'composing' | 'ready' | 'error', url, poster, seconds, sizeMb, title, clientText, clientReady, error }
 * Ishlatiladi: 🤖 Agent sinovi paneli, /m Nazoratchi kartalari. `dark` — /m qora mavzusi.
 */
import React from 'react';

export default function RunVideo({ video, apiUrl, dark = false }) {
  const [copied, setCopied] = React.useState(false);
  if (!video) return null;
  const box = dark
    ? 'bg-gray-900/60 border-gray-700 text-gray-200'
    : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-200';
  if (video.status === 'composing') {
    return <div className={`mt-2 rounded-lg border px-3 py-2 text-xs ${box} animate-pulse`}>🎥 Video montaj qilinmoqda… (odatda 1–2 daqiqa)</div>;
  }
  if (video.status !== 'ready' || !video.url) {
    return <div className={`mt-2 text-[11px] ${dark ? 'text-amber-300' : 'text-amber-700 dark:text-amber-400'}`}>🎥 Video yig'ilmadi: {String(video.error || "noma'lum sabab")}</div>;
  }
  const src = `${apiUrl}${video.url}`;
  const dl = `${apiUrl}/media/dl/${String(video.url).split('/').pop()}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(video.clientText || ''); setCopied(true); setTimeout(() => setCopied(false), 2000); }
    catch (e) { window.prompt('Nusxa oling:', video.clientText || ''); }
  };
  return (
    <div className={`mt-2 rounded-lg border p-2 ${box}`}>
      <div className="flex items-center gap-1.5 flex-wrap text-xs mb-1.5">
        <span className="font-semibold break-words" translate="no">🎥 {video.title}</span>
        <span className={dark ? 'text-gray-400' : 'text-gray-400 dark:text-gray-500'}>{video.seconds} s · {video.sizeMb} MB</span>
        {video.clientReady
          ? <span className="px-1.5 py-0.5 rounded-full text-[10px] bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300">mijozga tayyor</span>
          : <span className="px-1.5 py-0.5 rounded-full text-[10px] bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300">sinov o'tmagan — mijozga emas</span>}
      </div>
      <video controls preload="none" playsInline poster={video.poster ? `${apiUrl}${video.poster}` : undefined} src={src}
        className="w-full max-h-80 rounded bg-black" />
      <div className="flex gap-1.5 mt-1.5 flex-wrap">
        <a href={dl} className="px-2.5 py-1 rounded-lg text-xs font-medium bg-primary-700 dark:bg-primary-600 text-white hover:bg-primary-800">⬇ Yuklab olish</a>
        {video.clientText && (
          <button type="button" onClick={copy}
            title="Mijozga yuboriladigan matn: sarlavha, nima ko'rsatildi va natija"
            className={`px-2.5 py-1 rounded-lg text-xs font-medium border ${dark ? 'border-gray-600 text-gray-200' : 'border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700'}`}>
            {copied ? '✔ Nusxalandi' : '📋 Mijozga matn'}
          </button>
        )}
      </div>
    </div>
  );
}
